import { render } from "./QuestionStructure.vue?vue&type=template&id=04b917e8"
import script from "./QuestionStructure.vue?vue&type=script&lang=ts"
export * from "./QuestionStructure.vue?vue&type=script&lang=ts"

import "./QuestionStructure.vue?vue&type=style&index=0&id=04b917e8&lang=scss"
script.render = render

export default script